// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1jAoh","Success":"Button_Success__1D5qg","Danger":"Button_Danger__11F1N"};